let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jcIlS")).then(() => parcelRequire('1lg0L'));